module.exports = __webpack_public_path__ + "img/campaign_background_3.1ec77d69.png";